import { memo, type ReactNode } from 'react'

interface AuthCardProps {
  title: string
  children: ReactNode
  bottomSlot?: ReactNode
}

export const AuthCard = memo(({ title, children, bottomSlot }: AuthCardProps) => {
  return (
    <div className="auth-card">
      <h2 className="auth-card__title">{title}</h2>
      <div className="auth-card__content">{children}</div>
      {bottomSlot && <div className="auth-card__footer">{bottomSlot}</div>}
    </div>
  )
})

AuthCard.displayName = 'AuthCard'
